import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { MdClose } from '../../../Common/Icons';
import { restRequest } from '../../../Helpers/RequestHelper';
import PDFViewer from '../../../Components/PDFViewer/PDFViewer';
import {
  ActionMenu,
  Button,
} from '../../../Components/CheckedMenu/CheckedMenu';
import CustomModal from '../../../Components/CustomModal/CustomModal';
import Field from '../../../Components/Form/Field/Field';
import Pagination from '../../../Components/Pagination/Pagination';
// import PaginationX from '../../../Components/PaginationRoute/Pagination'
import ResetFilterIcon from '../../../Assets/General/ResetFilter';
import { checkError } from '../../../Helpers/AuthHelper';
import { pdfDownlaod } from '../../../Helpers/PdfDownload';
import useMobileDetection from '../../../Hooks/MobileDetect';
import { Loader, MultiItemSelect } from '../../../Components';
import { withTranslation } from 'react-i18next';
import { t } from 'i18next';
export const itemsCache = { selected: [] };
class ReportHeader extends Component {
  state = {
    showPDF: false,
    pdf: null,
    showFilterModal: false || this.props.showFilterModal,
    selectedItems: itemsCache.selected,
    itemsOptions: [],
    reportLoading: false,
  };

  openPdf() {
    const [hasMobile] = useMobileDetection();
    const { pdfMobileLink = '', from = '' } = this.props;
    if (hasMobile) {
      window.open(`/print/${from}?${pdfMobileLink}`, '_blank');
    } else {
      this.setState({ showPDF: true });
      restRequest('get', this.props.pdfLink)
        .then((res) => {
          this.setState({ pdf: res });
        })
        .catch((error) => {
          checkError(error);
        });
    }
  }

  closePDFModal = () => {
    this.setState({
      showPDF: false,
      pdf: null,
    });
  };

  renderPDF() {
    return (
      <PDFViewer
        showPDF={this.state.showPDF}
        hidePDFModal={this.closePDFModal}
        pdf={this.state.pdf}
      />
    );
  }
  renderWarehouseFilter() {
    return (
      <Field
        size="large"
        type="dropdown"
        name={this.props.t('report.warehouse')}
        autoFocus={true}
        className="inline-field"
        value={this.props.warehouse.selected}
        options={this.props.warehouse.options}
        dropdownValue="id"
        dropdownLabel="name"
        handleChange={this.props.warehouse.onChange}
        searchable={false}
      />
    );
  }
  renderDynamicContactFilter() {
    return (
      <>
        <div className="field-container   flex-25 form-field">
          <Field
            id="dynamicContacts"
            name="contacts"
            placeholder={t('common.select_customer')}
            autoFocus={true}
            size="large"
            clearable={false}
            // className="inline-field"
            type="DynamicPaginationDropdown"
            newCust={'CurrentCustomer'}
            value={this.state.selectedItemsData}
            // editCust={values.invoiceObj}
            // disabled={
            //   owner_can_edit_in_lock_status ||
            //   inModal ||
            //   (type === 'edit' && invoice.soId)
            // }
            addButton={false}
            required
            handleChange={this.props.dynamicContacts.onChange}
            // error={touched.customerId && errors.customerId}
            alphabetSort={true}
            // onBlur={() => {
            //   setFieldTouched('customerId', true);
            // }}
            api={`report/contact?contact_type=${this.props.type}`}
          />
        </div>
      </>
    );
  }
  renderContactFilter() {
    return (
      <Field
        size="large"
        type="dropdown"
        name={this.props.t('Settings.contacts')}
        autoFocus={true}
        className="inline-field"
        value={this.props.contact.selected}
        options={this.props.contact.options}
        dropdownValue="id"
        dropdownLabel="display_name"
        handleChange={this.props.contact.onChange}
        searchable={true}
      />
    );
  }

  renderSalePersonFilter() {
    return (
      <Field
        size="large"
        type="dropdown"
        name={this.props.t('report.sales_person')}
        autoFocus={true}
        className="inline-field"
        value={this.props.salesperson.selected}
        options={this.props.salesperson.options}
        dropdownValue="id"
        dropdownLabel="name"
        handleChange={this.props.salesperson.onChange}
        searchable={true}
      />
    );
  }

  renderStatusFilter() {
    return (
      <Field
        size="large"
        type="dropdown"
        name={this.props.t('report.status')}
        autoFocus={true}
        value={this.props.status.selected}
        options={this.props.status.options}
        className="inline-field"
        dropdownValue="id"
        dropdownLabel="label"
        handleChange={(option) =>
          this.props.status.onChange(option.id, 'status')
        }
        clearable={false}
      />
    );
  }

  renderStockTrackingFilter() {
    return (
      <Field
        size="large"
        type="dropdown"
        autoFocus={true}
        name={this.props.t('report.stockTracking')}
        value={this.props.stockTracking.selected}
        options={this.props.stockTracking.options}
        className="inline-field"
        dropdownValue="id"
        dropdownLabel="label"
        handleChange={(option) =>
          this.props.stockTracking.onChange(option.id, 'stockTracking')
        }
        clearable={false}
      />
    );
  } componentDidMount() {
    const prevPath = sessionStorage.getItem('lastReportPath') || '';
    const currentPath = window.location.pathname;

    if (prevPath.toLowerCase() !== currentPath.toLowerCase()) {
      itemsCache.selected = []; // ✅ clear when coming from different route
      this.setState({ selectedItems: [] });
    } else {
      // same route (internal remount) — restore from cache
      if (itemsCache.selected.length > 0) {
        this.setState({ selectedItems: itemsCache.selected });
      }
    }

    sessionStorage.setItem('lastReportPath', currentPath);
    this.fetchAndSetItemsOptions();
  }

  componentWillUnmount() {
    const currentPath = window.location.pathname;
    // ✅ if user is leaving this route, clear cache
    if (currentPath.toLowerCase() !== window.location.pathname.toLowerCase()) {
      itemsCache.selected = [];
    }
    // ✅ always clear session so next visit starts fresh
    sessionStorage.removeItem('lastReportPath');
  }
  // componentWillUnmount() {
  //   _cachedSelectedItems = [];
  // }
  // componentDidUpdate(prevProps) {
  //   if (
  //     prevProps.showFilterModal !== this.props.showFilterModal &&
  //     this.props.showFilterModal === true
  //   ) {
  //     // only open if parent explicitly opens it, never close from prop
  //     this.setState({ showFilterModal: true });
  //   }
  // }
  fetchAndSetItemsOptions() {
    this.setState({ reportLoading: true });
    // Fetch items options and set them in the state
    restRequest('get', 'report/items')
      // .then((response) => response.json())
      .then((data) => {
        this.setState({ itemsOptions: data.data });
        this.setState({ reportLoading: false });
      })
      .catch((error) => {
        console.error(error);
      });
  }
  handleFieldChange = (event) => {
    //console.log(event.target.value, "selected items")
    // Call the function to fetch and set items.options
    this.fetchAndSetItemsOptions();
    this.setState({ itemsSelected: event.target.value });
  };
  handleFieldFocus = () => {
    // console.log('Field focused');
    // avoid calling API again and again
    if (!this.state.hasFetched) {
      this.fetchAndSetItemsOptions();
    }
  };

  renderItemsFilter() {
    let items = this.props.items;
    let loading = this.props?.loading;
    let date = this.props?.dateRange?.value?.selection;

    // selectedItems are full objects stored in parent via items.onChange
    const selectedItems = this.state.selectedItems || [];

    return (
      <>
        <MultiItemSelect
          api="report/items"
          withImage={true}
          value={selectedItems}
          placeholder="Select Items"
          onChange={(updatedItems) => {
            itemsCache.selected = [...updatedItems];
            // store full objects in local state for display
            this.setState({ selectedItems: updatedItems });
            // pass only IDs up to parent report
            items.onChange(updatedItems.map((x) => x.id));
          }}
        />

        {this?.props?.from === 'sale_by_item' && (
          <>
            {loading && <Loader />}
            <div className="report--listing-outer">
              <ul className="report--listing">
                <li>
                  {t('common.currently_displaying_data_from_all_invoices')}
                  <span style={{ color: 'red' }}>
                    {t('common.irrespective_of_invoice_status')}
                  </span>
                </li>
                <li>
                  {t('common.data_shown_for_specified_date_range_from')}
                  {` ${date?.startDate?.format('MMM D, YY')} to ${date?.endDate?.format('MMM D, YY')}`}.
                </li>
                <li>{t('common.no_results_adjust_date_range')}</li>
              </ul>
            </div>
          </>
        )}
      </>
    );
  }

  renderSingleItemFilter() {

    let item = this.props.item;
    return (
      <Field
        size="large"
        type="dropdown"
        name={this.props.t('report.item_name_sku')}
        autoFocus={true}
        value={item.selected}
        options={item.options}
        className="inline-field"
        dropdownValue="id"
        dropdownLabel="name"
        additionalSearchFilter="sku"
        handleChange={item.onChange}
      />
    );
  }

  renderFilters() {
    let filters = [];
    for (let filter of this.props.filters) {
      switch (filter) {
        case 'warehouse':
          filters.push(this.renderWarehouseFilter());
          break;
        case 'status':
          filters.push(this.renderStatusFilter());
          break;
        case 'stockTracking':
          filters.push(this.renderStockTrackingFilter());
          break;
        case 'items':
          filters.push(this.renderItemsFilter());
          break;
        case 'item':
          filters.push(this.renderSingleItemFilter());
          break;
        case 'contact':
          filters.push(this.renderContactFilter());
          break;
        case 'salesperson':
          filters.push(this.renderSalePersonFilter());
          break;
        case 'dynamicContacts':
          filters.push(this.renderDynamicContactFilter());
          break;
        default:
          return;
      }
    }
    return filters;
  }

  renderFilterModal() {
    return (
      <CustomModal
        showModal={this.state.showFilterModal}
        title={this.props.t('report.customize_report')}
        onClose={() => this.setState({ showFilterModal: false })}
        renderActions={false}
        // minWidth={111}
        minWidth={
          this.renderFilters().length === 1
            ? 61
            : this.renderFilters().length <= 3
              ? 91
              : 111
        }
        size="large"
      >
        <div className=" report--filter-modal padding-bottom-J d-flex  reports--filter--popup">
          {this.renderFilters().map((filter, index) => (
            <Fragment key={index}>{filter}</Fragment>
          ))}
        </div>
      </CustomModal>
    );
  }
  renderResetFilter() {
    if (this.props.filters.length && this.props.showResetButton) {
      return (
        <button
          title={this.props.t('report.reset_filters')}
          className="checked-menu--button--icon-only "
          onClick={() => {
            if (this.props.filters.includes('items')) {
              this.props.items.selected = [];
              this.props.items.onChange(this.props.items.selected);
            }
            if (this.props.filters.includes('item')) {
              itemsCache.selected = [];
              this.props.item.selected = [];
              this.props.item.onChange(this.props.item.selected);
            }
            if (this.props.filters.includes('warehouse')) {
              this.props.warehouse.selected = null;
              this.props.warehouse.onChange(this.props.warehouse.selected);
            }
            if (this.props.filters.includes('status')) {
              this.props.status.selected = 'all';
              this.props.status.onChange(this.props.status.selected, 'status');
            }
            if (this.props.filters.includes('contact')) {
              this.props.contact.selected = 'all';
              this.props.contact.onChange(this.props.contact.selected);
            }
            if (this.props.filters.includes('salesperson')) {
              this.props.salesperson.selected = 'all';
              this.props.salesperson.onChange(this.props.salesperson.selected);
            }
            if (this.props.filters.includes('stockTracking')) {
              this.props.stockTracking.selected = 'shipments_receives';
              this.props.stockTracking.onChange(
                'shipments_receives',
                'stockTracking'
              );
            }
          }}
        >
          <ResetFilterIcon />
        </button>
      );
    }
    return <div />;
  }

  render() {
    return (
      <Fragment>
        {this.renderPDF()}
        {this.renderFilterModal()}
        <div className="center">
          <ActionMenu>
            {/* {!this.props.hasMobile ? ( */}
            <Button
              handleClick={() =>
                pdfDownlaod(
                  `${this.props.pdfLink}&download=true`,
                  this.props.pdfName,
                  this.props.toast
                )
              }
              type="pdf"
            />
            {/* ) : null} */}
            {/* {!this.props.hasMobile ? ( */}
            <Button handleClick={() => this.openPdf()} type="print" />
            {/* // ) : null} */}
            {this.renderResetFilter()}
            {/* <Button
              handleClick={() => this.setState({showFilterModal:true})}
              type="clone"
            /> */}
            {this.props.filters && this.props.filters.length > 0 && (
              <button
                onClick={() => this.setState({ showFilterModal: true })}
                className="button--primary float-left mr-3"
              >
                {this.props.t('report.customize_report')}
              </button>
            )}
          </ActionMenu>
          {/* <PaginationX
            generateRoute={this.props.generateRoute}
            history={this.props.history}
            viewPerPage={this.props.viewPerPage}
            totalPage={this.props.totalPage}
            currentPage={this.props.currentPage}
            /> */}

          <Pagination
            history={this.props.history}
            viewPerPage={this.props.viewPerPage}
            totalPage={this.props.totalPage}
            currentPage={this.props.currentPage}
            url={this.props.url}
            onPageChange={this.props.onPageChange}
            onViewPerPageChange={this.props.onViewPerPageChange}
          />
          <div className="close_icon reports_close">
            <Link to="/reports">
              <MdClose />
            </Link>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default withTranslation()(ReportHeader);
